<template>
  <v-dialog
    @keydown.esc="close"
    v-model="product_card"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-btn
        class="close default v-btn--simple"
        @click="close
                   
                   "
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-card-text v-if="product_card">
        <material-card class="card-tabs" color="#444">
          <v-flex slot="header">
            <v-tabs v-model="tabView" hide-slider="true" color="transparent" slider-color="white">
              <v-tab class="mr-3" @click="setTab(0)">
                <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>О товаре
              </v-tab>
              <v-tab class="mr-3" @click="setTab(1)">
                <v-icon class="mr-2">mdi-image-outline</v-icon>Фотографии
              </v-tab>
              <v-tab class="mr-3" @click="setTab(2)">
                <v-icon class="mr-2">mdi-qrcode</v-icon>Серийные номера
              </v-tab>

              <v-tab class="mr-3" @click="setTab(3)">
                <v-icon class="mr-2">mdi-web</v-icon>Ресурсы
              </v-tab>
              <v-tab class="mr-3" @click="setTab(4)">
                <v-icon class="mr-2">mdi-file-document-box-outline</v-icon>Характеристики
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-tabs-items>
            <v-tab-item>
              <div class="tab-product_card">
                <ProductInfo
                  :isUpdate="isUpdate"
                  :getProducts="getProducts"
                  :product_id="product_card"
                  v-if="tabs===0"
                />
                <ProductImages
                  :isUpdate="isUpdate"
                  :getProducts="getProducts"
                  :product_id="product_card"
                  v-else-if="tabs===1"
                />
                <ProductVariants :product_id="product_card" v-else-if="tabs===2" />
                <ProductResources :product_id="product_card" v-else-if="tabs===3" />
                <ProductFeatures :product_id="product_card" v-else-if="tabs===4" />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Loader from "../helper/Loader";
import ProductInfo from "./Product/ProductInfo";
import ProductImages from "./Product/ProductImages";
import ProductDescription from "./Product/ProductDescription";
import ProductVariants from "./Product/ProductVariants";
import ProductResources from "./Product/ProductResources";
import ProductFeatures from "./Product/ProductFeatures";

export default {
  components: {
    ProductFeatures,
    ProductResources,
    ProductVariants,
    ProductDescription,
    ProductImages,
    ProductInfo,
    Loader
  },
  data() {
    return {
      tabs: -1,
      tabView: 0
    };
  },
  methods: {
    ...mapMutations(["SET_PRODUCT_CARD", "SET_CHANGE"]),
    close() {
      if (this.change) {
        this.$dialog
          .confirm("У вас есть изменения. Вы точно хотите покинуть раздел?", {
            okText: "Да, хочу",
            cancelText: "Отмена"
          })
          .then(() => {
            this.SET_CHANGE(false);
            this.tabs = 0;
            this.SET_PRODUCT_CARD(null);
          })
          .catch(() => {});
      } else {
        this.tabs = this.tabView = 0;
        this.SET_PRODUCT_CARD(null);
      }
    },
    setTab(tab) {
      if (this.change) {
        this.$dialog
          .confirm("У вас есть изменения. Вы точно хотите покинуть раздел?", {
            okText: "Да, хочу",
            cancelText: "Отмена"
          })
          .then(() => {
            this.SET_CHANGE(false);
            this.tabs = this.tabView = tab;
          })
          .catch(() => {
            this.tabView = 0;
          });
      } else {
        this.tabs = this.tabView = tab;
      }
    }
  },
  watch: {},
  computed: {
    ...mapState(["product_card", "change"])
  },
  mounted() {
    this.tabs = this.tabView = 0;
  },
  created() {
    document.addEventListener("keyup", function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    });
  },
  props: ["getProducts", "isUpdate"]
};
</script>


<style lang="scss">
.tab-product_card {
  padding-top: 20px;
  min-height: 70vh;
  max-width: 95%;
  margin-left: auto;
  margin-right: auto;
}

.close {
  position: absolute !important;
  top: -8px;
  right: -13px;
  i {
    font-size: 80px;
  }
}
</style>
